// Libraries
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// Api
import { getListNotification, markReadAll } from 'api/notification'

// Models
import Notification, { STATUS_READED } from 'models/Notification'

// Async thunk
export const fetchNotifications = createAsyncThunk(
  'notifications/getList',
  async () => {
    const data = await getListNotification()

    return data
  }
)

export const markAsReadAll = createAsyncThunk(
  'notifications/markAsReadAll',
  async () => {
    await markReadAll()
  }
)

// Notification slice
export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notifications: [],
    loading: false,
    marking: false,
  },
  reducers: {
    markAsRead: (state, { payload }) => {
      const index = [...state.notifications].findIndex((x) => {
        return +x.id === +payload || +x.mappingId === +payload
      })

      if (index !== -1) {
        state.notifications[index].status = STATUS_READED
      }
    },
  },
  extraReducers: {
    [fetchNotifications.pending]: (state) => {
      state.loading = true
    },
    [fetchNotifications.fulfilled]: (state, { payload }) => {
      state.notifications = payload
      state.loading = false
    },
    [fetchNotifications.rejected]: (state) => {
      state.loading = false
    },
    [markAsReadAll.pending]: (state) => {
      state.loading = true
    },
    [markAsReadAll.fulfilled]: (state) => {
      state.notifications = [...state.notifications].map((notification) => {
        // Mark as read
        notification.status = STATUS_READED

        return notification
      })

      state.loading = false
    },
    [markAsReadAll.rejected]: (state) => {
      state.loading = false
    },
  },
})

// Action creators are generated for each case reducer function
export const { markAsRead } = notificationsSlice.actions

// Select state
export const selectLoading = (state) => state.notifications.loading
export const selectNotifications = (state) =>
  state.notifications.notifications.map((x) => new Notification(x))

export default notificationsSlice.reducer
